import { useDispatch } from "react-redux";
import {
  storeCoreUiSelectSidebarShow,
  storeCoreUiSelectSidebarUnfoldable,
  storeCoreUiSetLayout,
} from "../datasources/_coreui.layout.store.slice";
import { useCoreUiTypedSelector } from "../../../configs/_coreui.store.slice";

export const useCoreUiSidebarController = () => {
  const dispatch = useDispatch();
  const unfoldable = useCoreUiTypedSelector(storeCoreUiSelectSidebarUnfoldable);
  const sidebarShow = useCoreUiTypedSelector(storeCoreUiSelectSidebarShow);

  const setSidebarShow = (visible: boolean) => {
    dispatch(storeCoreUiSetLayout({ type: "set", sidebarShow: visible }));
  };
  const toggleSidebarFold = () => {
    dispatch(
      storeCoreUiSetLayout({ type: "set", sidebarUnfoldable: !unfoldable }),
    );
  };

  return {
    state: {
      unfoldable,
      sidebarShow,
    },
    action: {
      setSidebarShow,
      toggleSidebarFold,
    },
  };
};
